import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";

const OAuth2RedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const requested = useRef(false); // ✅ 중복 방지용 ref

  useEffect(() => {
    if (requested.current) return; // 🔥 두 번째 실행 차단
    requested.current = true;

    const params = new URLSearchParams(location.search);
    const code = params.get("code");
    const error = params.get("error");

    if (error) {
      navigate(`/login?error=${error}, { replace: true }`);
      return;
    }

    if (!code) {
      navigate("/login", { replace: true });
      return;
    }

    // ✅ 1) POST 요청으로 변경 (백엔드 AuthController와 일치)
    axios
      .post(
        `${process.env.REACT_APP_SPRING_API_URL}/api/auth/exchange?code=${code}`
      )
      .then((response) => {
        const { accessToken, username } = response.data;
        if (!accessToken) throw new Error("토큰 없음");

        localStorage.setItem("jwtToken", accessToken);
        localStorage.setItem("username", username);
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${accessToken}`;
        navigate("/", { replace: true });
      })
      .catch((err) => {
        console.error("❌ OAuth2 토큰 교환 실패:", err);
        navigate("/login?error=exchange_fail", { replace: true });
      });
  }, [location, navigate]);

  return <p>잠시만 기다려주세요...</p>;
};

export default OAuth2RedirectHandler;
